const Contact = () => {
    return (
        <div className={"box"}>
            <h3>Contact</h3>
        </div>
    );
};

export default Contact;